// Миксин для смены вкладок по клику в Motto

export default {
    methods: {
        setActiveTabFromHash() {
            if (!this.isExampleTab()) {
                return;
            }
            const index = window.location.hash.substring(10);
            this.setActiveTab(index);
        },

        isExampleTab() {
            return window.location.hash.substring(0, 9) === "#examples";
        },
    },

    mounted() {
        document.addEventListener("switch", this.setActiveTabFromHash);
    },
};
